module.exports = __webpack_public_path__ + "assets/img/bcd9ed6eb56438b4a0f5828368bd8237.svg";